module.exports = __webpack_public_path__ + "static/media/ManageVolunteers.a2c23199.svg";